/**
 * Barrel export file for HTTP interceptors
 * Provides easy imports for interceptor classes and providers
 */

export { IdentifierInterceptor } from './identifier.interceptor';

// Export interceptor providers for easy integration
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { IdentifierInterceptor } from './identifier.interceptor';

/**
 * Provider configuration for the IdentifierInterceptor
 * Use this in your app.config.ts or module providers array
 */
export const IDENTIFIER_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: IdentifierInterceptor,
  multi: true
};

/**
 * Array of all interceptor providers
 * Useful when you have multiple interceptors
 */
export const HTTP_INTERCEPTOR_PROVIDERS: Provider[] = [
  IDENTIFIER_INTERCEPTOR_PROVIDER
];
